import axiosClient from "api/axiosInstance";
import { SupplyPlans, SupplyPlan } from "api/models/NordPool";

export const getNordPoolSupplyPlans = async (
  fromDate: string,
  toDate: string,
): Promise<SupplyPlans> => {
  const client = axiosClient();

  const response = await client.get(
    `/supply-plans?from=${fromDate}&to=${toDate}`,
  );

  return response.data;
};

export const getNordPoolSupplyPlan = async (
  nordPoolSupplyPlanId: number,
): Promise<{ data: SupplyPlan }> => {
  const client = axiosClient();

  const response = await client.get(`/supply-plans/${nordPoolSupplyPlanId}`);

  return response.data;
};

export const exportNordPoolSubSupplyPlan = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/supply-plans/sub-plans/${id}/export`, {
    responseType: "blob",
  });

  return response.data;
};

export const exportNordPoolSupplyPlan = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/supply-plans/${id}/export`, {
    responseType: "blob",
  });

  return response.data;
};

export const generateNordPoolSupplyPlans = async (
  date: string,
  auctionTypeId: number,
  portfolioId?: number,
): Promise<any> => {
  const client = axiosClient();

  const portfolioIdQuery = portfolioId ? "&portfolioIds=" + portfolioId : "";

  const response = await client.post(
    `/supply-plans/generate?date=${date}&auctionTypeId=${auctionTypeId}${portfolioIdQuery}`,
  );

  return response.data;
};

export const importClientTrades = async (file: File) => {
  const client = axiosClient();

  const response = await client.post(
    `/nordpool/import-client-trades`,
    {
      file,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const submitNordPoolSupplyPlan = async (
  supplyPlanId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/nordpool/submit-supply-plan?supplyPlanId=${supplyPlanId}`,
  );

  return response.data;
};

export const exportNordPoolSupplyPlanResults = async (
  id: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/supply-plans/${id}/results/export`, {
    responseType: "blob",
  });

  return response.data;
};

type PriceStepResponseItem = number | { id?: number; value: number };

const extractPriceStepValues = (data: unknown): number[] => {
  if (!Array.isArray(data)) return [];
  return data
    .map((item: PriceStepResponseItem) =>
      typeof item === "number" ? item : item?.value,
    )
    .filter((value): value is number => typeof value === "number");
};

export const getNordPoolPriceSteps = async (): Promise<{ data: number[] }> => {
  const client = axiosClient();

  const response = await client.get(`/nordpool-price-steps`, {
    skipForbiddenRedirect: true,
  } as never);

  return { data: extractPriceStepValues(response.data?.data) };
};

export const updateNordPoolPriceSteps = async (
  values: number[],
): Promise<{ data: number[] }> => {
  const client = axiosClient();

  const response = await client.put(`/nordpool-price-steps`, { values });

  return { data: extractPriceStepValues(response.data?.data) };
};

export const forceUpdateNordPoolPriceSteps = async (): Promise<void> => {
  const client = axiosClient();

  await client.get(`/nordpool-price-steps/force-update`);
};
